import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { OAuth2Interceptor } from './interceptors/oauth2.interceptor';
import { OAuth2Service } from './services/oauth2.service';
import { EnhancedEncryptionService } from './services/enhanced-encryption.service';
import { SecureStorageService } from './services/secure-storage.service';
import {
  GLOBAL_SERVICES_KEY,
  GLOBAL_SERVICES_URL,
  OAUTH2_CLIENT_ID,
  OAUTH2_CLIENT_ID_EMEA,
} from '@maximizer/core/shared/data-access';

export interface OAuth2Config {
  globalServicesKey: string;
  globalServicesUrl: string;
  oauth2ClientId: string;
  oauth2ClientIdEmea: string;
}

export function provideOAuth2DataAccess(
  config: OAuth2Config,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    OAuth2Service,
    EnhancedEncryptionService,
    SecureStorageService,
    {
      provide: GLOBAL_SERVICES_KEY,
      useValue: config.globalServicesKey,
    },
    {
      provide: GLOBAL_SERVICES_URL,
      useValue: config.globalServicesUrl,
    },
    {
      provide: OAUTH2_CLIENT_ID,
      useValue: config.oauth2ClientId,
    },
    {
      provide: OAUTH2_CLIENT_ID_EMEA,
      useValue: config.oauth2ClientIdEmea,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OAuth2Interceptor,
      multi: true,
    },
  ]);
}
